export default __webpack_public_path__ + "static/media/checkin.1e55369f.svg";